import * as React from "react";
import { FileText, GripVertical, Trash2 } from "lucide-react";
import { Item } from "@/types/fse";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  item: Item;
  onDelete: (item: Item) => void;
}

export const AddGroupModalContentStep2Row: React.FC<Props> = ({ item, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? "transform 80ms cubic-bezier(0.22, 1, 0.36, 1)" : transition,
  };

  const handleDelete = () => {
    onDelete(item);
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`group flex cursor-move items-center justify-between rounded-lg border-2 bg-white px-4 py-3 transition-all duration-200 hover:shadow-md ${
        isDragging ? "scale-95 border-blue-300 opacity-50 shadow-lg" : "border-gray-200"
      }`}
    >
      <div className="flex items-center space-x-3">
        <GripVertical className="h-4 w-4 text-gray-400 group-hover:text-gray-600" />
        <FileText className="h-5 w-5 text-gray-500" />
        <span className="truncate text-sm font-medium text-gray-700">{item.name}</span>
      </div>

      <button
        onClick={handleDelete}
        className="rounded p-1 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-500"
        aria-label="Delete file"
        type="button"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  );
};
